import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CONFIG from "../utils/config";
import { FaUpload, FaFileAlt, FaCamera, FaIdCard, FaCar, FaCheckCircle, FaTimesCircle, FaChevronRight } from 'react-icons/fa';
import { MdDocumentScanner, MdCloudUpload, MdPhotoCamera } from 'react-icons/md';
import '../styles/Scanner.css';

const vehiclePhotoTypes = ["front", "back", "left", "right"];

const QuantumRenewalScanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id,activationDate,
    expirationDate, } = location.state || {};
    console.log("gsbvdhsg",activationDate)

  const [insuranceExpired, setInsuranceExpired] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [activeStep, setActiveStep] = useState(1);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [renProposalNumber, setRenProposalNumber] = useState("");
  const [insuredName, setInsuredName] = useState("");
  const [vehiclePhotoValidation, setVehiclePhotoValidation] = useState({
    front: null,
    back: null,
    left: null,
    right: null,
  });
  const [files, setFiles] = useState({
    qid: null,
    istimara: null,
    vehiclePhotos: {
      front: null,
      back: null,
      left: null,
      right: null,
    },
  });

  useEffect(() => {
    const fetchVehicleData = async () => {
      if (!id) {
        toast.error("Vehicle ID not found. Cannot proceed.");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const response = await fetch(`${CONFIG.BASE}/insurance/getVehicleData`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        });
        if (!response.ok) throw new Error("Failed to retrieve vehicle data");
        const data = await response.json();
        setRenProposalNumber(data.renProposalNumber); 
        setInsuredName(data.insuredName);
        // Vehicle age logic (not older than 10 years)
        const currentYear = new Date().getFullYear();
        const vehicleYear = parseInt(data.vehYear || data.manufacturingYear, 10); // fallback
        const isOlderThan10Years = (currentYear - vehicleYear) > 10;
        
        setInsuranceExpired(isOlderThan10Years ? "yes" : "no"); // reuse state for simplicity
  
        if (isOlderThan10Years) {
          toast.warn("Vehicle Age Expired");
        } else {
          toast.success("Vehicle is within 10 years. No additional docs required.");
        }
  
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
        toast.error("Unable to fetch vehicle details. Please try again.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchVehicleData();
  }, [id]);
  

  const handleFileChange = async (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;
  
    if (fileType.includes("vehiclePhotos")) {
      const photoKey = fileType.split(".")[1];
  
      // Set file locally first
      setFiles((prev) => ({
        ...prev,
        vehiclePhotos: {
          ...prev.vehiclePhotos,
          [photoKey]: file,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        [`vehiclePhotos.${photoKey}`]: null,
      }));
  
      setUploadProgress((prev) => ({ ...prev, [fileType]: 0 }));
      simulateUploadProgress(fileType);
  
      try {
        // Prepare form data for API
        const formData = new FormData();
        formData.append("images", file);
        formData.append("side", photoKey);
  
        const response = await fetch(CONFIG.SCANNER, {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) throw new Error("Side validation API failed");
  
        const result = await response.json();
  
        if (result.isvalid) {
          setVehiclePhotoValidation(prev => ({ ...prev, [photoKey]: true }));
          toast.success(result.message);
        } else {
          setVehiclePhotoValidation(prev => ({ ...prev, [photoKey]: false }));
          toast.error(result.message);
        }
      } catch (error) {
        console.error("Vehicle side validation error:", error);
        setVehiclePhotoValidation(prev => ({ ...prev, [photoKey]: false }));
        toast.error("Unable to validate vehicle photo side");
      }
  
    } else {
      // QID or Istimara file
      setFiles(prev => ({ ...prev, [fileType]: file }));
      setErrors(prev => ({ ...prev, [fileType]: null }));
      simulateUploadProgress(fileType);
    }
  };
  
  const simulateUploadProgress = (fileId) => {
    setUploadProgress(prev => ({ ...prev, [fileId]: 0 }));
    const interval = setInterval(() => {
      setUploadProgress(prev => {
        const newProgress = (prev[fileId] || 0) + 10;
        if (newProgress >= 100) {
          clearInterval(interval);
          return { ...prev, [fileId]: 100 };
        }
        return { ...prev, [fileId]: newProgress };
      });
    }, 100);
  };

  // const validate = () => {
  //   const newErrors = {};
  //   if (!files.qid) newErrors.qid = "QID document is required.";
  //   if (!files.istimara) newErrors.istimara = "Istimara document is required.";
  //   if (insuranceExpired === "yes") {
  //     vehiclePhotoTypes.forEach(photoType => {
  //       if (!files.vehiclePhotos[photoType]) {
  //         newErrors[`vehiclePhotos.${photoType}`] = `Vehicle ${photoType} photo is required.`;
  //       } else if (vehiclePhotoValidation[photoType] === false) {
  //         newErrors[`vehiclePhotos.${photoType}`] = `Vehicle ${photoType} photo side is incorrect.`;
  //       }
  //     });
  //   }
    
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };


  const validate = () => {
    const newErrors = {};
    if (!files.qid) newErrors.qid = "QID document is required.";
    if (!files.istimara) newErrors.istimara = "Istimara document is required.";
  
    if (insuranceExpired === "yes") {
      vehiclePhotoTypes.forEach(photoType => {
        if (photoType === "right") {
          // Skip validation for right side photo
          return;
        }
        if (!files.vehiclePhotos[photoType]) {
          newErrors[`vehiclePhotos.${photoType}`] = `Vehicle ${photoType} photo is required.`;
        } else if (vehiclePhotoValidation[photoType] === false) {
          newErrors[`vehiclePhotos.${photoType}`] = `Vehicle ${photoType} photo side is incorrect.`;
        }
      });
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validate()) {
      toast.error("Please fill all required fields and upload necessary documents.");
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      const formData = new FormData();
  
      // Use the same keys as your working curl/Postman request
      formData.append("proposalNo", renProposalNumber);
      formData.append("proposalDocCrBy", insuredName);
  
      if (files.qid) formData.append("qatar", files.qid);
      if (files.istimara) formData.append("vehicle_istimara", files.istimara);
  
      if (insuranceExpired === "yes") {
        if (files.vehiclePhotos.front) formData.append("vehicle_front", files.vehiclePhotos.front);
        if (files.vehiclePhotos.back) formData.append("vehicle_back", files.vehiclePhotos.back);
        if (files.vehiclePhotos.left) formData.append("vehicle_left", files.vehiclePhotos.left);
        if (files.vehiclePhotos.right) formData.append("vehicle_right", files.vehiclePhotos.right);
      }
  
      const response = await fetch(`${CONFIG.BASE}/scanner-docs/upload-multiple`, {
        method: "POST",
        body: formData,
      });
  
      if (!response.ok) {
        const errText = await response.text();
        throw new Error(errText || "Upload failed");
      }
  
      const result = await response.text();
      toast.success(result);
      navigate("/plan", { state: { id, insuranceExpired,
         passedActivationDate: activationDate,
          passedExpirationDate: expirationDate, } });
  
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(`Upload failed: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const removeFile = (fileType) => {
    if (fileType.includes("vehiclePhotos")) {
      const photoKey = fileType.split(".")[1];
      setFiles(prev => ({
        ...prev,
        vehiclePhotos: {
          ...prev.vehiclePhotos,
          [photoKey]: null,
        },
      }));
      setUploadProgress(prev => ({ ...prev, [fileType]: 0 }));
      setVehiclePhotoValidation(prev => ({ ...prev, [photoKey]: null }));
    } else {
      setFiles(prev => ({ ...prev, [fileType]: null }));
      setUploadProgress(prev => ({ ...prev, [fileType]: 0 }));
    }
  };

  // File Upload Card Component
  const FileUploadCard = ({ title, description, icon, fileType, accept, error }) => (
    <div className="quantum-upload-card">
      <div className="quantum-upload-card-inner">
        <div className="quantum-upload-icon">
          {icon}
        </div>
        <div className="quantum-upload-content">
          <h5 className="quantum-upload-title">{title}</h5>
          <p className="quantum-upload-desc">{description}</p>
          <div>
            {!files[fileType] ? (
              <>
                <input
                  type="file"
                  id={fileType}
                  accept={accept}
                  className="d-none"
                  onChange={(e) => handleFileChange(e, fileType)}
                />
                <label htmlFor={fileType} className="quantum-upload-btn" tabIndex={0}>
                  <FaUpload className="me-2" /> Upload File
                </label>
              </>
            ) : (
              <div className="quantum-file-preview">
                <div className="quantum-file-info">
                  <div className="quantum-file-icon">
                    <FaFileAlt />
                  </div>
                  <div className="quantum-file-details">
                    <p>{files[fileType].name}</p>
                    <small className="quantum-file-size">
                      {Math.round(files[fileType].size / 1024)} KB
                    </small>
                  </div>
                </div>
                <div className="quantum-file-actions">
                  {uploadProgress[fileType] < 100 ? (
                    <div className="quantum-progress">
                      <div 
                        className="quantum-progress-bar-inner" 
                        style={{ width: `${uploadProgress[fileType]}%` }}
                      ></div>
                    </div>
                  ) : (
                    <FaCheckCircle className="text-success me-2" />
                  )}
                  <button 
                    type="button" 
                    className="quantum-remove-btn"
                    onClick={() => removeFile(fileType)}
                    aria-label="Remove file"
                  >
                    <FaTimesCircle />
                  </button>
                </div>
              </div>
            )}
            {error && <div className="quantum-error">{error}</div>}
          </div>
        </div>
      </div>
    </div>
  );

  const VehiclePhotoUpload = ({ photoType }) => {
    const fileKey = `vehiclePhotos.${photoType}`;
    const file = files.vehiclePhotos[photoType];
    const error = errors[fileKey];
    const validation = vehiclePhotoValidation[photoType];

    return (
      <div className="quantum-vehicle-card">
  <div className="quantum-vehicle-card-body">
    <div className="quantum-vehicle-icon">
      <MdPhotoCamera size={24} />
    </div>
    <h6 className="quantum-vehicle-card-title">{photoType} View</h6>
    <p className="quantum-vehicle-card-desc">Upload {photoType} side photo of your vehicle</p>

    {!file ? (
      <>
        <input
          type="file"
          id={fileKey}
          accept="image/*"
          className="d-none"
          onChange={(e) => handleFileChange(e, fileKey)}
        />
        <label htmlFor={fileKey} className="quantum-vehicle-upload-btn" tabIndex={0}>
          <FaCamera className="me-2" /> Upload Photo
        </label>
      </>
    ) : (
      <div className="quantum-vehicle-preview">
        <div className="quantum-vehicle-image">
          {uploadProgress[fileKey] === 100 ? (
            <img src={URL.createObjectURL(file)} alt={photoType} />
          ) : (
            <div className="quantum-vehicle-loading">
              <div className="quantum-loading-spinner"></div>
              <p>Uploading...</p>
            </div>
          )}
        </div>
        <div className="quantum-vehicle-file-info">
          <div className="quantum-vehicle-file-details">
            {uploadProgress[fileKey] < 100 ? (
              <div className="quantum-progress me-2" style={{width: '60px', height: '6px'}}>
                <div 
                  className="quantum-progress-bar-inner" 
                  style={{ width: `${uploadProgress[fileKey]}%` }}
                ></div>
              </div>
            ) : (
              <>
                {validation === true && <FaCheckCircle className="text-success me-2" />}
                {validation === false && <FaTimesCircle className="text-danger me-2" />}
              </>
            )}
            <small className="text-muted">{file.name}</small>
          </div>
          <button 
            type="button" 
            className="quantum-remove-btn"
            onClick={() => {
              removeFile(fileKey);
              setVehiclePhotoValidation(prev => ({ ...prev, [photoType]: null }));
            }}
            aria-label="Remove photo"
          >
            <FaTimesCircle />
          </button>
        </div>
      </div>
    )}

    {error && <div className="quantum-error">{error}</div>}
    {validation === false && <div className="quantum-error">Uploaded side does not match: {photoType}</div>}
  </div>
</div>

    );
  };

  // Modal for vehicle photo uploads
  const VehiclePhotosModal = () => (
    showVehicleModal && (
      <div className="quantum-modal-overlay">
        <div className="quantum-modal">
          <div className="quantum-modal-header">
            <h5 className="quantum-modal-title">Upload Vehicle Photos</h5>
            <button 
              type="button" 
              className="quantum-modal-close" 
              onClick={() => setShowVehicleModal(false)}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="quantum-modal-body">
            <p className="text-muted">Upload clear photos of your vehicle from all four sides.</p>
            <div className="quantum-vehicle-grid">
              {vehiclePhotoTypes.map(photoType => (
                <VehiclePhotoUpload key={photoType} photoType={photoType} />
              ))}
            </div>
          </div>
          <div className="quantum-modal-footer">
            <button 
              type="button" 
              className="quantum-modal-btn quantum-modal-btn-secondary"
              onClick={() => setShowVehicleModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  );

  return (
    <div className="quantum-container">
      <div className="quantum-row">
        <div className="quantum-col">
          <div className="quantum-header">
            <div className="quantum-header-icon">
              <MdDocumentScanner size={28} />
            </div>
            <div>
              <h1 className="quantum-title">Quantum Renewal Scanner</h1>
              <p className="quantum-subtitle">Upload required documents for vehicle renewal process</p>
            </div>
          </div>

          {loading ? (
            <div className="quantum-card">
              <div className="quantum-loading-card">
                <div className="quantum-loading-spinner"></div>
                <p>Loading vehicle data...</p>
              </div>
            </div>
          ) : (
            <div className="quantum-main-grid">
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="quantum-card">
                    <div className="quantum-card-header">
                      <h5 className="quantum-card-title">Required Documents</h5>
                    </div>
                    <div className="quantum-card-body">
                      <FileUploadCard
                        title="QID Document"
                        description="Upload a clear copy of your Qatari ID card (front and back)"
                        icon={<FaIdCard size={24} />}
                        fileType="qid"
                        accept="image/*,application/pdf"
                        error={errors.qid}
                      />

                      <FileUploadCard
                        title="Istimara Document"
                        description="Upload your vehicle registration card (Istimara)"
                        icon={<FaFileAlt size={24} />}
                        fileType="istimara"
                        accept="image/*,application/pdf"
                        error={errors.istimara}
                      />

                      <div className="quantum-status-card">
                        <div className="quantum-card-body">
                          <div className="quantum-status-content">
                            <div className="quantum-upload-icon">
                              <FaCar size={24} />
                            </div>
                            <div>
                              <h5 className="quantum-upload-title">Insurance Status</h5>
                              <p className="quantum-upload-desc">
                                Your vehicle insurance status is automatically detected
                              </p>
                            </div>
                            <div className={`quantum-status-badge ${insuranceExpired === "yes" ? "quantum-status-expired" : "quantum-status-active"}`}>
                              {insuranceExpired === "yes" ? "Expired" : "Active"}
                            </div>
                          </div>
                        </div>
                      </div>

                      {insuranceExpired === "yes" && (
                        <div>
                          <button 
                            type="button" 
                            className="quantum-vehicle-btn"
                            onClick={() => setShowVehicleModal(true)}
                          >
                            <MdPhotoCamera className="me-2" /> Upload Vehicle Photos
                          </button>
                          <VehiclePhotosModal />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                  <button className="btn btn-cancel"
                  onClick={() => navigate(-1, { state: { id } })}>Back</button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="quantum-spinner"></span>
                        Processing...
                      </>
                    ) : (
                      <>
                        Proceed <FaChevronRight className="ms-2" />
                      </>
                    )}
                  </button>
                  </div>
                  
                </form>
              </div>
              <div>
                <div className="quantum-card quantum-summary-card">
                  <div className="quantum-summary-header">
                    <MdCloudUpload />
                    <h5 className="quantum-card-title">Upload Summary</h5>
                  </div>
                  <div className="quantum-card-body">
                    <ul className="quantum-summary-list">
                      <li className="quantum-summary-item">
                        <div className="quantum-summary-text">
                          <FaIdCard className="quantum-summary-icon" />
                          <span>QID Document</span>
                        </div>
                        <span className={files.qid ? "quantum-summary-status quantum-status-uploaded" : "quantum-summary-status quantum-status-pending"}>
                          {files.qid ? "Uploaded" : "Pending"}
                        </span>
                      </li>
                      <li className="quantum-summary-item">
                        <div className="quantum-summary-text">
                          <FaFileAlt className="quantum-summary-icon" />
                          <span>Istimara Document</span>
                        </div>
                        <span className={files.istimara ? "quantum-summary-status quantum-status-uploaded" : "quantum-summary-status quantum-status-pending"}>
                          {files.istimara ? "Uploaded" : "Pending"}
                        </span>
                      </li>
                      {insuranceExpired === "yes" && vehiclePhotoTypes.map(photoType => {
                        const fileKey = `vehiclePhotos.${photoType}`;
                        const file = files.vehiclePhotos[photoType];
                        return (
                          <li key={photoType} className="quantum-summary-item">
                            <div className="quantum-summary-text">
                              <FaCamera className="quantum-summary-icon" />
                              <span className="text-capitalize">{photoType} Photo</span>
                            </div>
                            <span className={file ? "quantum-summary-status quantum-status-uploaded" : "quantum-summary-status quantum-status-pending"}>
                              {file ? "Uploaded" : "Pending"}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuantumRenewalScanner;